export const basePath = "https://admin.witsoccer.com"; //Production
// export const basePath = "https://devwitsoccer.ioasys.com.br"; //Production

const Urls = {
  listEventsDates: `/api_web/list_events_dates`,
  getDateEvents: `/api_web/get_events`,
  subscribe: `/api_web/subscribe`,
  unsubscribe: `/api_web/unsubscribe/`,
  sendEmail: `/api_web/send_school_data`,
  listSoccerSchools: `/api_web/soccer_schools`,
  listSchoolAthletesInEvent: `/api_web/school_athletes`,
  getAllCities: `/api/v1/cities?uf_id=`,
  getAllCountries: `/api/v1/countries`,
  findAddressByCep: `/api/v1/find_cep`,
  sendLeedEmail: `/api_web/leads`
};

export default Urls;
